import React from "react";
import { ComplianceMastersTab } from "../../../masters/presentation/components/ComplianceMastersTab";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * LutPage — `/settings/lut`.
 *
 * The Letter of Undertaking: the document that lets exports be zero-rated
 * without paying IGST first. It belongs in settings because it is a setting in
 * the strict sense — a company-level record with validity dates that changes
 * how invoices dated inside its cover are taxed, rather than a report of
 * something that already happened.
 *
 * REUSES ComplianceMastersTab, the same way the Chart of Accounts panel reuses
 * GlsSection. It already carries the validity states (missing, expiring soon,
 * valid, expired), the upload-and-extract flow, the superseded history and the
 * customer export, and it is in production at `/dashboard/masters?tab=compliance`.
 * A second copy would be a second place to fix all of it.
 *
 * It also renders the ITC register, which is a report rather than a setting.
 * Kept deliberately: the user's call, 2026-08-08, was both. Splitting the
 * component to leave it out would mean editing a working screen to satisfy a
 * taxonomy, and a CA looking at export compliance is usually looking at input
 * credit in the same sitting.
 */
export const LutPage: React.FC = () => (
  <SettingsLayout wide>
    <SettingsManagedPanel
      title="LUT"
      description="Your Letter of Undertaking, and the input credit claimed against it."
    >
      <ComplianceMastersTab />
    </SettingsManagedPanel>
  </SettingsLayout>
);
